import angular from 'angular';
import isEmpty from 'lodash/isEmpty';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  subComponent: state.statsbar.activeComponent,
  loyaltyStatistics: state.user.loyaltyStatistics,
});

angular
  .module('myConsultApp')
  .controller('createRedeemPointsController', ($ngRedux, $rootScope, $scope, $http, ENV) => {
    $scope.initData = () => {
      $scope.redemptions = {
        rewards: [],
      };
      $scope.selectedReward = {
        reward: null,
        quantity: '',
      };
      $scope.initialReward = 'Select a Reward';
      $scope.redeemTotal = 0;
      $scope.redeemError = '';
      $scope.errors = [];
      $scope.filterRewards = [];
      $scope.processing_redeem_points = false;
      $scope.loadingRewards = false;
      $scope.fullRewardsList = [];
      $scope.display_reward_options = true;
    };

    $scope.init = () => {
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      $scope.initData();
    };

    $scope.validQuantity = () => {
      $scope.selectedReward.quantity = $scope.selectedReward.quantity.replace(/[^0-9]+/g, '');
    };

    $scope.filterRewardList = () => {
      let userAvailablePoints = 0;
      if(!isEmpty($scope.userInfo)){
        userAvailablePoints = $scope.userInfo.redeemable_points;
      }
      userAvailablePoints = userAvailablePoints - $scope.redeemTotal;
      let uniqueFilterRewardsArray = [];
      angular.forEach($scope.fullRewardsList, function (reward) {
        if (reward.point_cost > userAvailablePoints){
          uniqueFilterRewardsArray = [...uniqueFilterRewardsArray, reward];
        }
      });
      angular.forEach($scope.redemptions.rewards, function (reward) {
        let alreadyExists = false;
        if(uniqueFilterRewardsArray.length) {
          angular.forEach(uniqueFilterRewardsArray, function (existing_reward) {
            if(existing_reward.id == reward.reward.id){
              alreadyExists = true;
            }
          });
        }
        if(!alreadyExists){
          uniqueFilterRewardsArray = [...uniqueFilterRewardsArray, reward.reward];
        }
      });
      $scope.filterRewards = uniqueFilterRewardsArray;
      if(($scope.filterRewards.length + 1) == $scope.fullRewardsList.length){
        $scope.display_reward_options = false;
      } else {
        $scope.display_reward_options = true;
      }
    };

    $scope.addReward = () => {
      if (isEmpty($scope.selectedReward.reward) || !$scope.selectedReward.reward.id) {
        $scope.redeemError = 'Please select a reward.';
        return;
      }
      if (
        Number.isNaN($scope.selectedReward.quantity) ||
        Number($scope.selectedReward.quantity) === 0
      ) {
        $scope.redeemError = 'Please provide a valid quantity.';
        return;
      }

      const newRedeemTotal =
        $scope.redeemTotal +
        Number($scope.selectedReward.reward.point_cost) * Number($scope.selectedReward.quantity);
      
      let userAvailablePoints = 0;
      if(!isEmpty($scope.userInfo)){
        userAvailablePoints = $scope.userInfo.redeemable_points;
      }

      if (newRedeemTotal > userAvailablePoints) {
        $scope.redeemError = 'User does not have enough points to redeem selected reward.';
        return;
      }

      const reward = $scope.selectedReward;
      $scope.redemptions.rewards.push(reward);
      $scope.redeemTotal = newRedeemTotal;
      $scope.filterRewardList();
      $scope.redeemError = '';
      $scope.selectedReward = {
        reward: null,
        quantity: '',
      };
    };

    $scope.removeReward = (index) => {
      const removedReward = $scope.redemptions.rewards[index];
      $scope.redeemTotal -=
        Number(removedReward.quantity) * Number(removedReward.reward.point_cost);
      $scope.redemptions.rewards.splice(index, 1);
      $scope.filterRewardList();
      $scope.errors = [];
    };

    $scope.setRewardList = () => {
      $scope.loadingRewards = true;
      return $scope
        .getRewards($http, ENV, {
          enabled: 'true',
          available_for_order: 'true',
          paginate: false,
          order: 'parent_contentstack_uid,title',
        })
        .then((res) => {
          const userHasCard = $scope?.loyaltyStatistics?.redemption_status?.card_exists;
          $scope.fullRewardsList = res?.rewards?.filter((reward) => {
            // If loyalty statistics redemption_status.card_exists value is false, don’t show “reload card” option on rewards list
            if (reward.reward_type === 'reload_card' && !userHasCard) {
              return false;
            }
            return true;
          });
          $scope.filterRewardList();
          $scope.loadingRewards = false;
          return {
            rewards: $scope.fullRewardsList,
          };
        })
        .catch((e) => {
          $scope.loadingRewards = false;
          console.warn(e);
        });
    };

    $scope.selectReward = (option) => {
      $scope.selectedReward.reward = option;
    };

    $scope.searchClients = (query) => {
      return $scope
        .getUsers($http, ENV, {
          application_subscription: 5,
          is_active: true,
          is_anonymized: false,
          autoComplete: true,
          groups: 2,
          order: '-last_name',
          search: query,
        })
        .then((res) => res);
    };

    $scope.searchClientsPage = (query) => {
      return $scope.getUsersByUrl($http, query).then((res) => res);
    };

    $scope.selectUser = (data) => {
      if (!$rootScope.isUserPage && data && data !== undefined) {
        $rootScope.userId = data.id;
      }
    };

    $scope.submitRedemption = () => {
      $scope.processing_redeem_points = true;
      const payload = {
        redemptions: {
          user_id: $rootScope.userId,
          rewards: $scope.redemptions.rewards.map((reward) => ({
            reward_id: reward.reward.id,
            quantity: reward.quantity,
          })),
          usps_validate: false,
        },
      };
      $scope
        .createRedemption($http, ENV, payload)
        .then(() => {
          $scope.$apply(() => {
            $scope.initData();
            $rootScope.refreshLoyaltyStatistics();
            $rootScope.getData();
            $rootScope.closeComponent({ shouldHardClose: !$rootScope.isUserRoute });
            $scope.processing_redeem_points = false;
          });
        })
        .catch((error) => {
          $scope.processing_redeem_points = false;
          if (error.data['redemptions-groups']) {
            $scope.$apply(() => {
              $scope.errors = error.data['redemptions-groups'];
            });
            return;
          }
          const errors = error.data['redemptions-group'];
          let result = [];
          if (errors) {
            result = Object.keys(errors)
              .map((key) => {
                const keyString = key
                  .split('_')
                  .map((item) => $scope.capitalize(item))
                  .join(' ');
                const value = errors[key];
                if (Array.isArray(value)) {
                  return value.map((x) => `${keyString}: ${x}`);
                }
                return `${keyString}: ${errors[key]}`;
              })
              .flat(1);
          } else {
            result.push('Something went wrong. Please try again.');
          }

          $scope.$apply(() => {
            $scope.errors = result;
          });
        });
    };

    $scope.close = () => {
      $rootScope.closeComponent({ shouldHardClose: !$rootScope.isUserRoute });
    };

    $scope.$watch('subComponent', (newValue, oldValue) => {
      if (oldValue === 'redeem-points') {
        $scope.initData();
        if (!$rootScope.isUserRoute) {
          const e = document.getElementById('redeemed-user-name_value');
          if (e) {
            e.value = '';
            angular.element(e).triggerHandler('input');
          }
          $scope.setActiveUser({});
          $scope.setActiveUserInfo({});
        }
      }
    });

    const userInfoListener = $scope.$watch('userInfo', () => {
      if (!isEmpty($scope.userInfo)) {
        $scope.filterRewardList();
      }
    });

    $scope.init();
    $scope.$on('$destroy', () => {
      $scope.unsubscribe();
      userInfoListener();
    });
  })
  .directive('createRedeemPoints', () => {
    return {
      templateUrl: 'templates/v2/create-redeem-points.html',
    };
  });
